<template>
  <el-form
    :inline="inline"
    :model="model"
    class="demo-form-inline"
    ref="topForm"
    @keyup.enter.native="submit"
    :rules="rules"
  >
    <slot></slot>
    <span v-if="hasPerm(selectShowPower)">
      <el-button
        type="primary"
        v-if="selectShow"
        @click="needCheck ? handleCheck() : submit()"
        class="button-size"
        style="width: 110px"
      >
        查询
      </el-button>
      <el-button
        type="primary"
        v-if="needReset"
        @click="reset()"
        class="button-size"
      >
        重置
      </el-button>
    </span>
    <span v-if="hasPerm(addShowPower)">
      <el-button
        v-if="show"
        :type="buttonType"
        @click="add()"
        class="button-size"
        style="width: 125px"
      >
        {{ buttonName }}
      </el-button>
    </span>
    <!-- 送券按钮 -->
    <span v-if="hasPerm(giveCoupons)">
      <el-button
        style="width: 130px"
        v-if="shows"
        :type="buttonType"
        @click="give()"
        class="button-size"
      >
        {{ giveName }}
      </el-button>
    </span>
    <!-- 强制退款 -->
    <span v-if="hasPerm(forceRefund)">
      <el-button
        v-if="forceShow"
        :type="forceShowType"
        @click="force()"
        class="button-size"
        style="width: 110px"
      >
        {{ forceName }}
      </el-button>
    </span>
    <!-- 一键切换 -->
    <span v-if="hasPerm(clickSwitch)">
      <el-button
        v-if="clickShow"
        :type="clickShowType"
        @click="click()"
        class="button-size"
        style="width: auto"
      >
        {{ clickName }}
      </el-button>
    </span>
    <!-- 新增需求 -->
    <span v-if="hasPerm(clickSwitchOpen)">
      <el-button
        v-if="clickShowOpen"
        :type="clickShowTypeOpen"
        @click="clickOpen()"
        class="button-size"
        style="width: auto"
      >
        {{ clickNameOpen }}
      </el-button>
    </span>
    <!-- 新增费率修改 -->
    <span v-if="hasPerm(clickSwitchMoney)">
      <el-button
        v-if="clickShowMoney"
        :type="clickShowTypeMoney"
        @click="clickMoney()"
        class="button-size"
        style="width: auto"
      >
        {{ clickNameMoney }}
      </el-button>
    </span>
    <!-- 合计 -->
    <span v-if="hasPerm(totaltext)">
      <el-button
        v-if="totalShow"
        :type="totalShowType"
        @click="total()"
        class="button-size"
        style="width: 110px"
      >
        {{ totalName }}
      </el-button>
    </span>
    <!-- 新增审核 -->
    <span v-if="hasPerm(textButton)">
      <el-button
        v-if="textShow"
        :type="textShowType"
        @click="text()"
        class="button-size"
        style="width: 110px"
      >
        {{ totalName }}
      </el-button>
    </span>
    <span v-if="hasPerm(cutShowPower)">
      <el-button
        v-if="cutButton"
        type="primary"
        @click="cut()"
        class="button-size"
      >
        扣款
      </el-button>
    </span>
    <span v-if="hasPerm(uploadPower)">
      <el-button
        v-if="uploadPower"
        :type="uploadPowerType"
        @click="upload()"
        class="button-size"
        style="width: 110px"
      >
        {{ uploadPowerText }}
      </el-button>
    </span>
    <span v-if="hasPerm(downloadPower)">
      <el-button
        v-if="showDownloadPower"
        :type="showDownloadPowerType"
        @click="down()"
        class="button-size"
        style="width: 110px"
      >
        {{ downloadPowerText }}
      </el-button>
    </span>
    <!-- 新增批量修改 -->
    <span v-if="changeButtonText == '批量修改'">
      <el-button
        v-if="showChangeButton"
        :type="showChangeButtonType"
        @click="changeButton()"
        class="button-size"
        style="width: 110px"
      >
        {{ changeButtonText }}
      </el-button>
    </span>
    <!-- 更改活动 -->
    <span v-if="hasPerm(upActivity)">
      <el-button
        v-if="upActivityShow"
        :type="upActivityType"
        @click="upActivitycz()"
        class="button-size"
      >
        {{ upActivityName }}
      </el-button>
    </span>
    <!-- 机具回收 -->
    <span v-if="hasPerm(implementRecovery)">
      <el-button
        v-if="implementRecoveryShow"
        :type="implementRecoveryType"
        @click="implementRecoverycz()"
        class="button-size"
      >
        {{ implementRecoveryName }}
      </el-button>
    </span>
    <!-- 批量通过 -->
    <span v-if="hasPerm(batchpass)">
      <el-button
        v-if="batchShow"
        :type="batchShowType"
        @click="batch()"
        class="button-size"
        style="width: 125px; padding: 0"
      >
        {{ batchName }}
      </el-button>
    </span>
    <!-- 机具下发 -->
    <span v-if="hasPerm(implementIssued)">
      <el-button
        v-if="implementIssuedShow"
        :type="implementIssuedType"
        @click="implementIssuedcz()"
        class="button-size"
        style="width: 125px"
      >
        {{ implementIssuedName }}
      </el-button>
    </span>

    <span>
      <el-button
        v-if="goback"
        type="primary"
        @click="goBack()"
        class="button-size"
      >
        返回
      </el-button>
    </span>
    <!-- 新返回,携带参数，就先这么写 -->
    <span>
      <el-button
        v-if="gobackNew"
        type="primary"
        @click="goBackNew()"
        class="button-size"
      >
        返回
      </el-button>
    </span>
    <!-- 文件上传按钮 -->
    <span>
      <el-upload
        class="el-form-item"
        accept=".xlsx"
        ref="aaaaa"
        prop="file"
        :action="uploadUrl"
        name="file"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
      >
        <el-button
          v-if="showUploadFile"
          :type="uploadFileType"
          class="button-size"
        >
          {{ uploadFileText }}
        </el-button>
      </el-upload>
    </span>
  </el-form>
</template>

<script>
import { submitMixin } from "mixin";
import { ergodicKeys } from "common/js/common-utils";
import SubmitText from "mixin/model/SubmitText";
import Server from "common/conf/Server";

export default {
  name: "CommonTopForm",
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    rules: {
      type: Object,
      default: null,
    },
    inline: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
    shows: {
      type: Boolean,
      default: false,
    },
    forceShow: {
      type: Boolean,
      default: false,
    },
    clickShow: {
      type: Boolean,
      default: false,
    },
    clickShowOpen: {
      type: Boolean,
      default: false,
    },
    clickShowMoney: {
      type: Boolean,
      default: false,
    },
    totalShow: {
      type: Boolean,
      default: false,
    },
    textShow: {
      type: Boolean,
      default: false,
    },
    batchShow: {
      type: Boolean,
      default: false,
    },
    needReset: {
      type: Boolean,
      default: false,
    },
    selectShow: {
      type: Boolean,
      default: true,
    },
    buttonShow: {
      type: Boolean,
      default: false,
    },
    cutButton: {
      type: Boolean,
      default: false,
    },
    showDownloadPower: {
      type: Boolean,
      default: false,
    },
    showChangeButton: {
      type: Boolean,
      default: false,
    },
    showUploadFile: {
      type: Boolean,
      default: false,
    },
    needCheck: {
      type: Boolean,
      default: false,
    },
    needBeforeSubmit: {
      type: Boolean,
      default: false,
    },
    selectShowPower: {
      type: String,
      default: "",
    },
    addShowPower: {
      type: String,
      default: "",
    },
    // 送券
    giveCoupons: {
      type: String,
      default: "",
    },
    // 强制退款
    forceRefund: {
      type: String,
      default: "",
    },
    // 一键切换
    clickSwitch: {
      type: String,
      default: "",
    },
    clickSwitchOpen: {
      type: String,
      default: "",
    },
    clickSwitchMoney: {
      type: String,
      default: "",
    },
    // 合计
    totaltext: {
      type: String,
      default: "",
    },
    // 审核
    textButton: {
      type: String,
      default: "",
    },
    // 批量通过
    batchpass: {
      type: String,
      default: "",
    },
    downloadPower: {
      type: String,
      default: "",
    },
    // uploadFiles: {
    //   type: String,
    //   default: "",
    // },
    uploadPower: {
      type: String,
      default: "",
    },
    cutShowPower: {
      type: String,
      default: "",
    },
    buttonName: {
      type: String,
      default: "添加",
    },
    giveName: {
      type: String,
      default: "送券",
    },
    forceName: {
      type: String,
      default: "强制退款",
    },
    clickName: {
      type: String,
      default: "一键切换",
    },
    clickNameOpen: {
      type: String,
      default: "变更开户信息",
    },
    clickNameMoney: {
      type: String,
      default: "变更费率信息",
    },
    totalName: {
      type: String,
      default: "合计",
    },
    batchName: {
      type: String,
      default: "批量通过",
    },
    submitService: {
      type: Function,
      default: null,
    },
    submitData: {
      type: Object,
      default: null,
    },
    failTitle: {
      type: String,
      default: null,
    },
    loadingText: {
      type: String,
      default: null,
    },
    failText: {
      type: String,
      default: null,
    },
    successText: {
      type: String,
      default: null,
    },
    buttonType: {
      type: String,
      default: "primary",
    },
    forceShowType: {
      type: String,
      default: "primary",
    },
    clickShowType: {
      type: String,
      default: "primary",
    },
    clickShowTypeOpen: {
      type: String,
      default: "primary",
    },
    clickShowTypeMoney: {
      type: String,
      default: "primary",
    },
    showDownloadPowerType: {
      type: String,
      default: "primary",
    },
    showChangeButtonType: {
      type: String,
      default: "primary",
    },
    uploadFileType: {
      type: String,
      default: "warning",
    },
    totalShowType: {
      type: String,
      default: "primary",
    },
    textShowType: {
      type: String,
      default: "primary",
    },
    batchShowType: {
      type: String,
      default: "primary",
    },
    uploadPowerType: {
      type: String,
      default: "primary",
    },
    downloadPowerText: {
      type: String,
      default: "导出",
    },
    changeButtonText: {
      type: String,
      default: "",
    },
    uploadFileText: {
      type: String,
      default: "上传",
    },
    uploadPowerText: {
      type: String,
      default: "批量上传",
    },
    // 更改活动
    upActivity: {
      type: String,
      default: "",
    },
    upActivityShow: {
      type: Boolean,
      default: false,
    },
    upActivityType: {
      type: String,
      default: "primary",
    },
    upActivityName: {
      type: String,
      default: "更改活动",
    },
    // 机具回收
    implementRecovery: {
      type: String,
      default: "",
    },
    implementRecoveryShow: {
      type: Boolean,
      default: false,
    },
    implementRecoveryType: {
      type: String,
      default: "primary",
    },
    implementRecoveryName: {
      type: String,
      default: "机具回收",
    },
    // 机具下发
    implementIssued: {
      type: String,
      default: "",
    },
    implementIssuedShow: {
      type: Boolean,
      default: false,
    },

    implementIssuedType: {
      type: String,
      default: "primary",
    },
    implementIssuedName: {
      type: String,
      default: "机具下发",
    },
    goback: {
      type: Boolean,
      default: false,
    },
    gobackNew: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [submitMixin],
  data() {
    return {
      uploadUrl:
        Server[process.env.NODE_ENV] +
        "8880/tatPublicPlatoonPeopleSuper/uploadfile",
      validMap: {},
      canSubmit: false,
    };
  },
  mounted() {
    ergodicKeys(this.rules, (key) => {
      this.validMap[key] = !(typeof this.rules[key][0].required == "function"
        ? this.rules[key][0].required()
        : this.rules[key][0].required);
    });
  },
  methods: {
    add() {
      this.$emit("openAddDialog");
    },
    // 送
    give() {
      this.$emit("giveAddDialog");
    },
    // 强制退款
    force() {
      this.$emit("checks");
    },
    // 一键切换
    click() {
      this.$emit("click");
    },
    clickOpen() {
      this.$emit("clickOpen");
    },
    clickMoney() {
      this.$emit("clickMoney");
    },
    // 合计
    total() {
      this.$emit("totalLookDialog");
    },
    // 合计
    text() {
      this.$emit("textLookDialog");
    },
    // 批量通过
    batch() {
      this.$emit("batchLookDialog");
    },
    reset() {
      this.$emit("reset");
    },
    cut() {
      this.$emit("cut");
    },
    upload() {
      this.$emit("upload");
    },
    down() {
      this.$emit("down");
      this.showLoading();
    },
    changeButton() {
      this.$emit("changeButton");
    },
    handleCheck() {
      this.$emit("check");
    },
    //更改活动
    upActivitycz() {
      this.$emit("upActivitycz");
    },
    //机具回收
    implementRecoverycz() {
      this.$emit("implementRecoverycz");
    },
    //机具下发
    implementIssuedcz() {
      this.$emit("implementIssuedcz");
    },
    goBack() {
      this.$router.back();
    },
    goBackNew() {
      this.$emit("goBackNew");
    },
    submit: function () {
      if (this.needBeforeSubmit) {
        this.$emit("beforeSubmit");
        return;
      }
      this.showLoading();
      const params = this.submitData == null ? this.model : this.submitData;
      ergodicKeys(params, (key) => {
        if (typeof params[key] == "string") {
          params[key] = params[key].trim();
        }
      });
      this.doValidAndSubmit(
        "topForm",
        this.submitService,
        params,
        (res) => {
          this.hideLoading();
          this.$emit("success", res);
        },
        new SubmitText({
          failTitle: this.failTitle,
          loadingText: this.loadingText,
          successText: this.successText,
          failText: this.failText,
        }),
        (error) => {
          this.hideLoading();
          this.$emit("fail", error);
        }
      );
    },

    // 文件上传
    handleSuccess(res, file, fileList) {
      if (
        "0000" != res.respCode ||
        (res.contents &&
          res.contents.optStatus &&
          "0000" != res.contents.optStatus)
      ) {
        this.handleCancel();
        if (!res.contents) {
          return this.showError(res.respMsg || res.respCode + ":未知错误");
        }
        return this.showError(
          res.contents.optMsg || res.contents.optStatus + ":未知错误"
        );
      } else {
        this.showSuccess(res.respMsg);
      }
    },
    handleCancel() {
      this.$refs.aaaaa.clearFiles();
    },
    handleBeforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg == "xls";
      const extension2 = testmsg == "xlsx";
      const limitSize = file.size != 0;
      if (!extension && !extension2 && !limitSize) {
        this.$refs.aaaaa.clearFiles();
        this.$message.warning("上传文件只能是 xls、xlsx格式 或 文件不能为空！");
      }
      return extension || extension2 || limitSize;
    },
  },
};
</script>

<style scoped>
.button-size {
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommonTopForm.vue